import React from "react"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import classNames from "classnames"
import { FormattedMessage, useIntl } from "react-intl"

import { GA_EVENTS } from "../../../constants/analytics"
import CustomLink from "../CustomLink"
import CustomNavLink from "../CustomNavLink"

// Redux
import { selectIsFreemiumUser } from "../../../redux/selectors/selectIsFreemiumUser"

// Hooks
import { useLogout } from "../../../hooks/useLogout"

const Navbar = () => {
  const { pathname } = useLocation()
  const auth = useSelector((state) => state.auth)
  const { formatMessage } = useIntl()

  const { handleLogout } = useLogout();

  const isFreemium = useSelector(selectIsFreemiumUser);

  const menuItems = []

  if (auth.role?.role === "TeamOwner") {
    menuItems.push({
      name: formatMessage({ id: "sidebar.teamMembers" }),
      type: "link",
      to: "/manage-team",
    })
  }

  menuItems.push(
    {
      name: formatMessage({ id: "navbar.settings" }),
      type: "link",
      to: "/settings",
    },
    {
      name: formatMessage({ id: "navbar.logout" }),
      type: "button",
      onClick: handleLogout,
    },
  )

  return (
    <div className="navbar">
      <div className="navbar__wrapper">
        <div className="navbar__menus">
          <CustomLink
            className={classNames("navbar__sourcing-link", { selected: pathname.startsWith("/sourcing") })}
            to={"/sourcing"}
            trackingEvent={GA_EVENTS.NAV.SOURCING}
          >
            <FormattedMessage id="navbar.sourcing" />
            <span className="navbar__new-pip">
              <FormattedMessage id="navbar.new" />
            </span>
          </CustomLink>
          <CustomLink
            className={classNames({ selected: pathname.includes("/select-cv") })}
            to={"/job-match/select-cv"}
            trackingEvent={GA_EVENTS.NAV.SELECT_CV}
          >
            <FormattedMessage id="navbar.candidateCVs" />
          </CustomLink>
          <CustomLink
            className={classNames({ selected: pathname.includes("/matches") })}
            to={"/job-match/matches"}
            trackingEvent={GA_EVENTS.NAV.JOB_MATCHES}
          >
            <FormattedMessage id="navbar.jobMatches" />
          </CustomLink>
          {!isFreemium && (
            <CustomNavLink
              className={({ isActive }) => classNames({ selected: isActive })}
              to={"/buy-more"}
              trackingEvent={GA_EVENTS.NAV.BUY_MORE}
            >
              <FormattedMessage id="navbar.buyAddOns" />
            </CustomNavLink>
          )}

          {/* // TODO: Check if still necessary */}
          {/* <CustomLink
            to={"/job-match/select-cv"}
            className={classNames({
              selected:
                pathname.includes("job-match") && !pathname.includes("matches"),
            })}
            trackingEvent={GA_EVENTS.NAV.NEW_JOB_MATCH}
          >
            <FormattedMessage id="navbar.newJobMatch" />
          </CustomLink> */}
        </div>
      </div>
    </div>
  )
}

export default Navbar
